module.exports = __webpack_public_path__ + "assets/img/video-thumb-2.800a8ab4.webp";